import script from "./VNumericQuarterTableColumn.vue?vue&type=script&setup=true&lang=ts"
export * from "./VNumericQuarterTableColumn.vue?vue&type=script&setup=true&lang=ts"

import "./VNumericQuarterTableColumn.vue?vue&type=style&index=0&id=698c69b3&lang=scss"

const __exports__ = script;

export default __exports__